<template>
	<div class="horizontal-menu">
		<nav class="navbar top-navbar">
			<div class="container bg_green">
				<div class="navbar-content">
					<nav class="bottom-navbar">
						<div class="container bg_green">
							<ul class="nav page-navigation">
								<li v-if="[0, 1, 3].includes(userRole)" class="nav-item" :class="(SM_movimientos.match(routeName)) ? 'active' : ''">
									<a href="#" class="nav-link">
										<i class="link-icon" data-feather="truck"></i>
										<span class="menu-title">Movimientos</span>
										<i class="link-arrow"></i>
									</a>
									<div class="submenu">
										<ul class="submenu-item">
											<li class="nav-item">
												<router-link to="/movimientos" class="nav-link" :class="routeName === 'movimientos' ? 'active' : ''">
													<span class="link-title">Movimientos</span>
												</router-link>
											</li>
											<li class="nav-item">
												<router-link to="/movimiento" class="nav-link" :class="routeName === 'movimiento' ? 'active' : ''">
													<span class="link-title">Cargar Manual</span>
												</router-link>
											</li>

										</ul>
									</div>
								</li>								
								<li v-if="[0, 1, 2, 3].includes(userRole)" class="nav-item" :class="(SM_cruds.match(routeName)) ? 'active' : ''">
									<a href="#" class="nav-link">
										<i class="link-icon" data-feather="settings"></i>
										<span class="menu-title">Mantención</span>
										<i class="link-arrow"></i>
									</a>
									<div class="submenu">
										<ul class="submenu-item">
											<li class="nav-item" v-if="[0, 1].includes(userRole)">
												<router-link to="/users" class="nav-link" :class="routeName === 'users' ? 'active' : ''">
													<span class="link-title">Usuarios</span>
												</router-link>
											</li>
											<li class="nav-item" v-if="[0, 1, 2, 3].includes(userRole)">
												<router-link to="/empresas" class="nav-link" :class="routeName === 'empresas' ? 'active' : ''">
													<span class="link-title">Proveedores y Clientes</span>
												</router-link>
											</li>
											<li class="nav-item" v-if="[0, 1, 2, 3].includes(userRole)">
												<router-link to="/odestinos" class="nav-link" :class="routeName === 'odestinos' ? 'active' : ''">
													<span class="link-title">Origenes - Destinos</span>
												</router-link>
											</li>
											<li class="nav-item" v-if="[0, 1].includes(userRole)">
												<router-link to="/productos" class="nav-link" :class="routeName === 'productos' ? 'active' : ''">
													<span class="link-title">Materiales</span>
												</router-link>
											</li>
											<li class="nav-item" v-if="[0, 1, 2].includes(userRole)">
												<router-link to="/tmovimientos" class="nav-link" :class="routeName === 'tmovimientos' ? 'active' : ''">
													<span class="link-title">Tipo de Movimientos</span>
												</router-link>
											</li>							
											<li class="nav-item" v-if="[0, 1, 2].includes(userRole)">
												<router-link to="/tcamiones" class="nav-link" :class="routeName === 'tcamiones' ? 'active' : ''">
													<span class="link-title">Tipo de Camiones</span>
												</router-link>
											</li>
											<li class="nav-item" v-if="[0, 1, 2].includes(userRole)">
												<router-link to="/mprecios" class="nav-link" :class="routeName === 'lprecios' ? 'active' : ''">
													<span class="link-title">Precios x Movimiento</span>
												</router-link>
											</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</div>
		</nav>
	</div>
</template>

<script>
export default {
	name: "Menu",
	data() {
		return {
			userRole: window.Laravel.user.seg_rol_id,
			routeName: null, //se usa para marcar la opcion activa
			//opciones por submenus, se usa para marcar el submenu activo
			SM_movimientos: 'movimientos',
			SM_informes: '/informes/recepcion /informes/prod /informes/despacho',
			SM_cruds: 'users empresas pprecios choferes despachadores odestinos productos tdocumentos gastos'
		}
	},
	watch: {
		'$route': 'currentRoute'
	},

	methods: {
		currentRoute(e) {
			this.$nextTick(() => {
				this.routeName = window.location.pathname.substring(1, 1000)
			})
		}
	},
}
</script>
